import { Section as BaseSection } from "../components/Section";
import * as React from "react";
import styled from "styled-components";
import alternatiba from "../assets/images/alternatiba.png";
import amnesty from "../assets/images/amnesty.png";
import la_base from "../assets/images/la_base.png";
import le_monde from "../assets/images/le_monde.png";
import les_canaux from "../assets/images/les_canaux.png";
import notre_choix from "../assets/images/notre_choix.png";
import ocean_stream from "../assets/images/ocean_stream.png";
import on_est_pret from "../assets/images/on_est_pret.png";
import pacte_transition from "../assets/images/pacte_transition.png";
import surfrider from "../assets/images/surfrider.png";
import railcoop from "../assets/images/railcoop.png";
import ilots from "../assets/images/ilots.png";
import * as chunk from "lodash.chunk";
import { Slider } from "../components/Slider";
import { TABLET } from "../constant/Breakpoints";

interface PartnerProps {
  name: string;
  img: string;
}

const PARTNERS: PartnerProps[] = [
  {
    name: "Alternatiba",
    img: alternatiba,
  },
  {
    name: "Amnesty",
    img: amnesty,
  },
  {
    name: "La Base",
    img: la_base,
  },
  {
    name: "Le Monde",
    img: le_monde,
  },
  {
    name: "Les Canaux",
    img: les_canaux,
  },
  {
    name: "Notre Choix",
    img: notre_choix,
  },
  {
    name: "Ocean Stream",
    img: ocean_stream,
  },
  {
    name: "On est Prêt",
    img: on_est_pret,
  },
  {
    name: "Pacte pour la Transition",
    img: pacte_transition,
  },
  {
    name: "Surfrider Foundation",
    img: surfrider,
  },
  {
    name: "Railcoop",
    img: railcoop,
  },
  {
    name: "Ilots",
    img: ilots,
  },
];

const PartnerSmall = styled.img`
  width: 45%;
  max-height: 40vw;
  margin: 0 2.5%;
  object-fit: contain;
`;

const PARTNER_ITEMS = PARTNERS.map(({ img, name }) => (
  <PartnerSmall src={img} alt={name} />
));

const Section = styled(BaseSection)`
  padding-top: 0;
  padding-bottom: 0;
  @media (max-width: ${TABLET}px) {
    display: none;
  }
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: ${TABLET}px) {
    flex-wrap: nowrap;
  }
`;

const Partner = styled.img`
  width: 14%;
  max-height: 10vw;
  margin: 0.5%;
  object-fit: contain;
`;

export const Partners = () => (
  <Section id="partners">
    <Flex>
      {PARTNERS.map(({ name, img }, i) => (
        <Partner key={i} src={img} alt={name} />
      ))}
    </Flex>
  </Section>
);

const SectionSmall = styled(BaseSection)`
  position: relative;
  display: none;
  padding-top: 0;
  padding-bottom: 0;

  @media (max-width: ${TABLET}px) {
    display: inline;
  }
`;

const chunkedPartners = chunk(PARTNER_ITEMS, 2);

export const PartnersSmall = () => (
  <SectionSmall>
    <Slider slides={chunkedPartners} isAutomatic={true} />
  </SectionSmall>
);
